import React from 'react';
import './Pagination.css';

const Pagination = ({ 
  currentPage, 
  totalPages, 
  onPageChange, 
  itemsPerPage, 
  totalItems,
  onItemsPerPageChange 
}) => {
  // Генерируем массив номеров страниц для отображения
  const getPageNumbers = () => {
    const delta = 2; // Количество страниц слева и справа от текущей
    const range = [];
    const rangeWithDots = [];
    let l;

    for (let i = 1; i <= totalPages; i++) {
      if (i === 1 || i === totalPages || (i >= currentPage - delta && i <= currentPage + delta)) {
        range.push(i);
      }
    }

    range.forEach((i) => {
      if (l) {
        if (i - l === 2) {
          rangeWithDots.push(l + 1);
        } else if (i - l !== 1) {
          rangeWithDots.push('...');
        }
      }
      rangeWithDots.push(i);
      l = i;
    });

    return rangeWithDots;
  };

  if (totalPages <= 1) {
    return null; // Не показываем пагинацию, если только одна страница
  }

  const startItem = (currentPage - 1) * itemsPerPage + 1;
  const endItem = Math.min(currentPage * itemsPerPage, totalItems);

  return (
    <div className="pagination-container">
      <div className="pagination-info">
        <span>
          Показано {startItem}-{endItem} из {totalItems}
        </span>
        {onItemsPerPageChange && (
          <div className="items-per-page">
            <label>Показывать по:</label>
            <select 
              value={itemsPerPage} 
              onChange={(e) => onItemsPerPageChange(Number(e.target.value))}
              className="form-control form-control-sm"
            >
              <option value={12}>12</option>
              <option value={24}>24</option>
              <option value={48}>48</option>
              <option value={96}>96</option>
            </select>
          </div>
        )}
      </div>
      
      <div className="pagination-controls">
        <button 
          className="btn btn-sm btn-outline-secondary"
          onClick={() => onPageChange(1)}
          disabled={currentPage === 1}
          title="В начало"
        >
          ««
        </button>
        
        <button 
          className="btn btn-sm btn-outline-secondary"
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
          title="Предыдущая страница"
        >
          «
        </button>
        
        <div className="page-numbers">
          {getPageNumbers().map((number, index) => (
            number === '...' ? (
              <span key={`dots-${index}`} className="page-dots">...</span>
            ) : (
              <button
                key={number}
                onClick={() => onPageChange(number)}
                className={`btn btn-sm ${currentPage === number ? 'btn-primary' : 'btn-outline-secondary'}`}
              >
                {number}
              </button>
            )
          ))}
        </div>
        
        <button 
          className="btn btn-sm btn-outline-secondary"
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          title="Следующая страница"
        >
          »
        </button>
        
        <button 
          className="btn btn-sm btn-outline-secondary"
          onClick={() => onPageChange(totalPages)}
          disabled={currentPage === totalPages}
          title="В конец"
        >
          »»
        </button>
      </div>
    </div>
  );
};

export default Pagination;